// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-null[data-v-313cd3fc]{margin:-35px 0 -35px 0;height:calc(100% + 35px)}.scroll-null .settings__title[data-v-313cd3fc]{padding-top:70px;margin-top:0}[data-v-313cd3fc] .data__url p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}[data-v-313cd3fc] .loader{margin-top:29px}", ""]);
// Exports
module.exports = exports;
